import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { Product } from '@common/product';

export type ProductViewMode = 'grid' | 'list';

@Injectable({
  providedIn: 'root'
})
export class ViewStateService {
  private readonly viewModeKey = 'product_view_mode';
  private viewMode = new BehaviorSubject<ProductViewMode>('grid');
  public viewMode$ = this.viewMode.asObservable();

  private quickViewProductSubject = new BehaviorSubject<Product | null>(null);
  public quickViewProduct$ = this.quickViewProductSubject.asObservable();

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.loadInitialViewMode();
  }

  private loadInitialViewMode(): void {
    if (isPlatformBrowser(this.platformId)) {
      const savedMode = localStorage.getItem(this.viewModeKey) as ProductViewMode;
      if (savedMode === 'list' || savedMode === 'grid') {
        this.viewMode.next(savedMode);
      } else {
        this.viewMode.next('grid'); // Default to grid
      }
    }
  }

  setViewMode(mode: ProductViewMode): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(this.viewModeKey, mode);
      this.viewMode.next(mode);
    }
  }

  openQuickView(product: Product): void {
    this.quickViewProductSubject.next(product);
  }

  closeQuickView(): void {
    this.quickViewProductSubject.next(null);
  }
}
